import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
// Uncomment if those are needed for some components, currently throw some linting errors
// import { camelize, getCurrentInstance, toHandlerKey } from 'vue';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
